import Molde from "./MoldeTourTradicional";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import CardItinerario from "../common/card/CardItinerario";
import React from 'react';


export default function CuscoMistico() {
  return (
    <>
      <Molde
        image={"/images/cusco_mistico_portada.png"}
        title={"CUSCO MISTICO"}
        subtitle={"(FULL DAY)"}
        description={
          "Adéntrate en el lado mágico de Cusco visitando cuatro fantásticos escenarios: esculturas monumentales que recuerdan a dioses incas, criaturas mitológicas, paisajes eco-restaurados y figuras inspiradas en el cine de fantasía. Todo esto en una excursión de día completo cerca de la ciudad"
        }
        linkForm={"/reservar/citytour-dia"}
        /*tipoprecio={"Precio por persona"}
        monto={"US$ 30.00"}
        moneda={"DOLARES"}*/
        picture1={            
          <>
          <div>
            <CardItinerario
              num="01"
              title="INICIO"
              lugar="MORADA DE LOS DIOSES - Apukunaq Tianan"
              ></CardItinerario>

              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/morada_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/morada_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/morada_3.png`} alt="" />
              </div>
          </div>
          </>
        }

        picture2={            
          <>
          <div>
            <CardItinerario
              num="02"
              title="PARADA"
              lugar="VALLE DE LOS DUENDES"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/duende_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/duende_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/duende_3.png`} alt="" />
              </div>
            </div>
          </>
        }

        picture3={            
          <>
          <div>
            <CardItinerario
              num="03"
              title="PARADA"
              lugar="HUMEDAL DE HUASAO"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/huasao_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/huasao_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/huasao_3.png`} alt="" />
              </div>
            </div>
          </>
        }
        picture4={            
          <>
          <div>
            <CardItinerario
              num="04"
              title="PARADA"
              lugar="BOSQUE DE LOS ENTS"
              ></CardItinerario>
              <div className="pt-4 grid grid-cols-1 lg:grid-cols-3 p-2 lg:gap-4 gap-2 bg-primary-100">
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/ents_1.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/ents_2.png`} alt="" />
                <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/ents_3.png`} alt="" />
              </div>
            </div>
          </>
        }

        incluye={
          <>
            <p className="text-primary-800 font-light">Transporte turistico</p>
            
            <p className="text-primary-800 font-light">Asistencia permanente</p>
            <p className="text-primary-800 font-light">Almuerzo</p>
          </>
        }
        noIncluye={
          <>
            <p className="text-primary-800 font-light">Boleto turistico </p>
            <p className="text-primary-800 font-light">Gastos extra</p>
            <p className="text-primary-800 font-light">Desayuno</p>
            <p className="text-primary-800 font-light">Cena</p>
          </>
        }
        caracteristica={
            <>
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
                title={"Dificultad"}
                desc={"Facil"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
                title={"Tipo Servicio"}
                desc={"Compartido"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
                title={"Duración"}
                desc={"Full day"}
              />
              <CardCaracteristica
                icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
                title={"Tipo de Tour"}
                desc={"Cultural - trek"}
              />
            </>
          }

        lugarvisita={
                  <>
                    <CardLugar
                      icon={"01"}
                      title={"MORADA DE LOS DIOSES"}
                    />
                    <CardLugar
                      icon={"02"}
                      title={"VALLE DE LOS DUENDES "}
                    />
                    <CardLugar
                      icon={"03"}
                      title={"HUMEDAL DE HUASAO"}
                    />
                    <CardLugar
                      icon={"04"}
                      title={"BOSQUE DE LOS ENTS"}
                    />
                    
                  </>
                }
                
        TourRecomienda={
          <>
            <CardRecomienda
                          img={"/images/montania_colores.png"}
                          title={"MONTAÑA 7 COLORES"}
                          puntuacion={"4.5"}
                          link={'/tour-tradicional/montania-colores'}
                        />
                        <CardRecomienda
                          img={"/images/valle-vip-5.png"}
                          title={"VALLE VIP"}
                          puntuacion={"5"}
                          link={'/tour-tradicional/valle-vip'}
                        />
                        <CardRecomienda
                          img={"/images/laguna_huamantay.png"}
                          title={"LAGUNA HUAMANTAY"}
                          puntuacion={"5"}
                          link={'/tour-tradicional/laguna-huamantay'}
                        />
                        <CardRecomienda
                          img={"/images/maras-moray-4.png"}
                          title={"MARAS-MORAY"}
                          puntuacion={"4.5"}
                          link={'/tour-tradicional/maras-moray'}
                        />
          </>
        }
      />
    </>
  );
}
